import React, { FC } from 'react'

const SearchIcon: FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.0001 11.5001C19.0001 7.35793 15.6422 4.00006 11.5001 4.00006C7.35793 4.00006 4.00006 7.35793 4.00006 11.5001C4.00006 15.6422 7.35793 19.0001 11.5001 19.0001C13.5714 19.0001 15.4454 18.1621 16.8038 16.8038C18.1621 15.4454 19.0001 13.5714 19.0001 11.5001ZM21.0001 11.5001C21.0001 13.7628 20.2062 15.8404 18.8858 17.4717L21.7071 20.293C22.0976 20.6836 22.0976 21.3166 21.7071 21.7071C21.3166 22.0976 20.6836 22.0976 20.293 21.7071L17.4717 18.8858C15.8404 20.2062 13.7628 21.0001 11.5001 21.0001C6.25336 21.0001 2.00006 16.7468 2.00006 11.5001C2.00006 6.25336 6.25336 2.00006 11.5001 2.00006C16.7468 2.00006 21.0001 6.25336 21.0001 11.5001Z"
      fill="currentColor"
    />
  </svg>
)

export default SearchIcon
